import React from 'react';
import '../components/css/popupstyle.css';
import $ from 'jquery';
import loader from '../../src/components/css/dark/img/loader.gif';

class AddUserPopup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            password: '',
            cpassword: '',
            btnClick: false
        };
    }  

    handleDashboard = e => {
        $('#userame').removeClass('errorIcon');
        $('#email').removeClass('errorIcon');
       try {
            var errCount = 0;
            let fieldValue = [];
            let field1 = $('#userame').val();
            let field2 = $('#email').val();

            if (field1 == '' || field1 == null || field1 == undefined) {
                $('#userame').addClass('errorIcon');
                $('.password').show();
                $('.password').text('Please enter user name');
                errCount = errCount + 1;
            }
           if (field2 == '' || field2 == null || field2 == undefined) {
               $('#email').addClass('errorIcon');
                $('.re-password').show();
                $('.re-password').text('Please enter email id');
                errCount = errCount + 1;
            }
            else {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (re.test(String(field2).toLowerCase()) == false) {
                    $('#email').addClass('errorIcon');
                    $('.re-password').show();
                    $('.re-password').text('Please enter valid email id');
                    errCount = errCount + 1;
                }
            }
            if (errCount == 0) {
                this.setState({ btnClick: true });
                fieldValue.push(field1);
                fieldValue.push(field2);
                this.props.handleDashboard(fieldValue);
            }
            else {
                return false;
            }
        }
        catch (error) {}
    }
    render() {
        return (

            <div className='tool-section report confirmClose adminConfirmPassword'>
                <div className='popup report-section'>
                    <div className='popup_inner'>
                        <h1>{this.props.titleText}</h1>
                        <div className="pop-btn resendPassword">
                            <input type="text" id="userame" value={this.props.currentWholesalerName} placeholder="Name" className="form-control wholesalerN" />
                            <div className="error-message password"></div>
                            <input type="email" id="email" className="form-control" placeholder="Email" />
                            <div className="error-message re-password"></div>
                            <div className="clear"></div>
                            <button className="btn" onClick={this.handleDashboard}>Create</button>
                            <button className="btn cancel" onClick={this.props.closePopup}>Cancel</button>
                            {
                                this.state.btnClick == true ?
                                    <img className="loader confirmClick" src={loader} alt="loader" /> : null
                                    }
                        </div>

                    </div>
                </div>
            </div>

        )
    }
}

export default AddUserPopup;